// @ts-nocheck
import React from 'react';
import KeyCloak from "../../Auth/Keycloak";
import { Link } from "react-router-dom";
import localStorageManagement from "../../Security/LocalStorageManagement";
import { useBody } from "../state/BodyContext";
import Collapse from '@mui/material/Collapse';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItemIcon from '@mui/material/ListItemIcon';
import { useAuth } from "../../Auth/State/AuthContext";

const parentSx = {
    mx: 0.5,
    borderRadius: 2,
    color: '#2d2d2d',
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
        color: '#B71234',
    },
    '& .MuiListItemIcon-root': {
        color: 'inherit',
        minWidth: 44,
    },
};

const childSx = {
    pl: 4,
    mx: 0.5,
    borderRadius: 2,
    color: '#2d2d2d',
    transition: 'color 0.2s, background-color 0.2s',
    '&:hover': {
        backgroundColor: 'rgba(183, 18, 52, 0.06)',
        color: '#B71234',
    },
};

export function MenuDesplegable({ openMenu, opciones, value, icon, addMenuItemView, modulo, ...props }) {
    const { openM, setOpenM } = useBody();
    const [open, setOpen] = React.useState(false);
    const { hasRole } = useAuth();

    React.useEffect(() => {
        setOpenM(openMenu);
        setOpen(openMenu);
    }, [openMenu]);

    const handleClick = () => {
        setOpen(!open);
        setOpenM(true);
    };

    return (
        <div>
            <ListItemButton sx={parentSx} onClick={handleClick}>
                <ListItemIcon>
                    {icon}
                </ListItemIcon>
                <ListItemText primary={modulo} />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {opciones.map((o, index) => {
                        const roles = o.rol;
                        const link = o.link;
                        const canView = !roles || hasRole(roles);

                        return canView ? (
                            <Link key={index} onClick={() => { addMenuItemView(modulo); }}
                                to={link}
                                style={{ textDecoration: 'none' }}>
                                <ListItemButton sx={childSx}>
                                    <ListItemText primary={o.nombre} />
                                </ListItemButton>
                            </Link>
                        ) : null;
                    })}
                </List>
            </Collapse>
        </div>
    );
}
